module.exports = __webpack_public_path__ + "img/inu_gallery8.50f7b8f2.jpg";